<script setup>
// ArticleContent.vue — Wrapper that decides between backend diff_html and plain viewer.

import { computed } from 'vue'
import VuetifyViewer from '@/tiptap/components/VuetifyViewer.vue'

const props = defineProps({
  latestJson: { type: Object, required: true },
  // Kept for API compatibility with callers; no longer used for client-side diffing.
  lastReadJson: { type: Object, default: null },
  latestHistoryId: { type: [String, Number], required: true },
  lastReadHistoryId: { type: [String, Number], default: null },
  diffHtml: { type: String, default: '' },
  latestHtml: { type: String, default: '' },

  // optional visual overrides (not required)
  dark: { type: Boolean, default: undefined },
  dense: { type: Boolean, default: false },
  extensions: { type: Array, default: () => [] },
  openTick: { type: Number, default: 0 },
})

const showDiff = computed(() =>
  !!props.lastReadHistoryId && props.lastReadHistoryId !== props.latestHistoryId
)

const hasServerDiffHTML = computed(() =>
  showDiff.value && typeof props.diffHtml === 'string' && props.diffHtml.trim().length > 0
)

const plainViewerValue = computed(() => {
  // Read mode: HTML-first for fast production rendering.
  if (typeof props.latestHtml === 'string' && props.latestHtml.trim().length > 0) {
    return props.latestHtml
  }
  return props.latestJson
})

</script>

<template>
  <VuetifyViewer
    v-if="hasServerDiffHTML"
    :key="['diff-html', latestHistoryId, lastReadHistoryId, diffHtml.length].join(':')"
    :value="diffHtml"
    :dark="dark"
    :dense="dense"
    :extensions="extensions"
  />
  <VuetifyViewer
    v-else
    :key="['viewer', latestHistoryId].join(':')"
    :value="plainViewerValue"
    :dark="dark"
    :dense="dense"
    :extensions="extensions"
  />
</template>
